<script>
import ProcessFlowForm from "@/driver/pages/masters/recycle_disposal_patterns/flows/_Form.vue";

export default {
  name: "MasterFlow",
  components: {
    ProcessFlowForm,
  },
  props: {},
  data () {
    return {
      breadcrumbs: [
        { text: '再資源化等パターン', disabled: false, to: '/driver/masters/recycle_disposal_patterns', exact: true },
        { text: '処理フロー詳細', disabled: true, to: '' },
      ],
      targetId: null,
    }
  },
  watch: {},
  computed: {},
  created() {
    this.targetId = parseInt(this.$route.params.id);
  },
  methods: {}
}
</script>

<template>
  <v-container fluid>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <process-flow-form
      :target-id="targetId"
      referenceOnly
    />
  </v-container>
</template>

<style scoped lang="scss">

</style>
